var _rect, _path, _ellipse, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 83,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 71 83)",
    fill: "#F1EDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.601 71.509C166.051 71.6737 166.05 72.326 165.601 72.4905C159.726 74.6413 157.641 76.7253 155.49 82.6008C155.326 83.0502 154.674 83.0504 154.509 82.601C152.357 76.7277 150.274 74.6438 144.399 72.491C143.949 72.3263 143.95 71.674 144.399 71.5095C150.274 69.3587 152.359 67.2747 154.51 61.3992C154.674 60.9498 155.326 60.9496 155.491 61.399C157.643 67.2723 159.726 69.3562 165.601 71.509Z",
    fill: "url(#paint0_linear_7320_93583)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 23.5,
    rx: 4.5,
    ry: 4.5,
    transform: "rotate(90 46.5 23.5)",
    fill: "#00FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7148 61.7148C81.8946 61.7148 87.7148 55.8946 87.7148 48.7148C87.7148 41.5351 81.8946 35.7148 74.7148 35.7148C67.5351 35.7148 61.7148 41.5351 61.7148 48.7148C61.7148 55.8946 67.5351 61.7148 74.7148 61.7148Z",
    stroke: "url(#paint1_linear_7320_93583)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8577 132.286H63.572L59.8577 100.715H48.7148V87.7148C48.7148 73.3554 60.3554 61.7148 74.7148 61.7148C87.8132 61.7148 98.6493 71.4006 100.452 84.0006",
    stroke: "url(#paint2_linear_7320_93583)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4043 106.066C99.4043 102.446 102.339 99.5117 105.959 99.5117H138.732C142.352 99.5117 145.287 102.446 145.287 106.066V125.73C145.287 129.351 142.352 132.285 138.732 132.285H105.959C102.339 132.285 99.4043 129.351 99.4043 125.73V106.066Z",
    stroke: "url(#paint3_linear_7320_93583)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.375 99.5117V92.8192C113.375 88.7165 116.701 85.3906 120.803 85.3906H123.868C127.971 85.3906 131.297 88.7165 131.297 92.8192V99.5117",
    stroke: "url(#paint4_linear_7320_93583)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7320_93583",
    x1: 166.727,
    y1: 71.8033,
    x2: 127.531,
    y2: 84.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7320_93583",
    x1: 87.4194,
    y1: 48.5017,
    x2: 44.9573,
    y2: 62.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7320_93583",
    x1: 99.8637,
    y1: 96.4221,
    x2: 11.1958,
    y2: 118.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7320_93583",
    x1: 144.766,
    y1: 115.63,
    x2: 76.5008,
    y2: 147.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7320_93583",
    x1: 131.093,
    y1: 92.3354,
    x2: 103.537,
    y2: 104.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroker);
export default __webpack_public_path__ + "static/media/broker.094157105d3456ff29877524993d43d8.svg";
export { ForwardRef as ReactComponent };